import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form, Transfer, message } from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncSetGroup, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;

class SetGroup extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                await this.props.asyncSetGroup(formatFormData(values));
                message.success('成功');
                this.props.asyncGet();
                this.props.form.resetFields();
                this.props.modalHide();
            }
        });
    };
    filterOption = (inputValue, option) => {
        const [sId, cId] = inputValue.split('-');
        if (sId && cId) {
            return option.shelfId.indexOf(sId) > -1 && option.clientId.indexOf(cId) > -1;
        }
        if (sId) {
            return option.shelfId.indexOf(sId) > -1;
        }
        if (cId) {
            return option.clientId.indexOf(cId) > -1;
        }
    }

    handleChange = targetKeys => {
        this.props.getTransferData({ selectedRowKeys: targetKeys });
    }

    renderItem = item => {
        const customLabel = (
            <span span={6}>{item.shelfId}-{item.clientId}</span>
        );
        return {
            label: customLabel, // for displayed item
            value: item.shelfId, // for title and filter matching
        };
    }
    render() {
        const { isModalShow, isLoading, item = {}, listAll, transferData } = this.props;
        const { selectedRowKeys = [] } = transferData;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="分组ID">
                            {getFieldDecorator('groupId', {
                                initialValue: item.groupId || '',
                                rules: [],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="分组名称">
                            {getFieldDecorator('note', {
                                initialValue: item.note || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入分组名称',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="分组类型">
                            {getFieldDecorator('groupType', {
                                initialValue: item.groupType,
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择分组类型',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="ANDROID">ANDROID</Option>

                                    <Option value="LINUX">LINUX</Option>

                                    <Option value="IOS">IOS</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="目标客户端">
                            {getFieldDecorator('clientList', {
                                initialValue: selectedRowKeys,
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择目标客户端',
                                    },
                                ],
                            })(
                                <Transfer
                                    titles={['待选数据', '选中数据']}
                                    dataSource={listAll}
                                    showSearch
                                    filterOption={this.filterOption}
                                    targetKeys={selectedRowKeys}
                                    onChange={this.handleChange}
                                    render={this.renderItem}
                                />)}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    isModalShow: state.clientList.uiStatus.isSetGroupShow,
    isLoading: state.clientList.uiStatus.isLoading,
    listAll: state.clientList.listAll,
    transferData: state.clientList.transferData,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isSetGroupShow: false })),
    asyncSetGroup: contents => dispatch(asyncSetGroup(contents)),
    asyncGet: () => dispatch(asyncGet()),
    getTransferData: data => dispatch(actions.getTransferData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(SetGroup));



// WEBPACK FOOTER //
// ./pages/client/clientList/setGroup.js